import {
  Route,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import Footer from "@/layout/Footer";
import { AnimatePresence } from "framer-motion";
import Motion from "@/components/animations/Motion";
import RootNav from "@/layout/RootNav";
import { ROUTE_PATH } from "@/constants/routePath";
import { useEffect } from "react";

// 브라우저의 자동 스크롤 복원 기능을 비활성화합니다.
// 이 코드는 모듈 최상단에서 실행되어, React 렌더링 이전에 적용됩니다.
// 이를 통해 브라우저가 애니메이션 로직과 충돌하는 것을 방지합니다.
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

const SCROLL_KEY_PREFIX = "scroll_";
export type ROUTE_KEY = "" | "project" | "board";
export type PATHNAME<T> = Record<ROUTE_KEY, T>;

const AppRoute = (): JSX.Element => {
  const location = useLocation();
  const navigationType = useNavigationType();

  const scrollKey = `${SCROLL_KEY_PREFIX}${location.pathname}`;

  useEffect(() => {
    // 페이지를 떠날 때 현재 스크롤 위치를 세션 스토리지에 저장합니다.

    return () => {
      sessionStorage.setItem(scrollKey, window.scrollY.toString());
    };
  }, [scrollKey, location.pathname]);

  const handleAnimationComplete = () => {
    const savedPosition = sessionStorage.getItem(scrollKey);

    if (savedPosition && navigationType === "POP") {
      // 이중 requestAnimationFrame으로 레이아웃 계산 후 스크롤을 보장합니다.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          console.log("✅ POP - 복원 실행:", savedPosition);
          window.scrollTo(0, Number(savedPosition));
          sessionStorage.removeItem(scrollKey);
        });
      });
    } else {
      requestAnimationFrame(() => {
        console.log("⬆️ PUSH - 최상단 이동");
        window.scrollTo(0, 0);
      });
    }
  };
  return (
    <>
      <RootNav />
      <main className="">
        <AnimatePresence mode="wait" onExitComplete={handleAnimationComplete}>
          <Routes location={location} key={location.pathname}>
            {ROUTE_PATH.map(({ path, Component }) => (
              <Route
                key={path}
                path={path}
                element={<Motion.Page key={path}>{Component}</Motion.Page>}
              />
            ))}
          </Routes>
        </AnimatePresence>
        <Footer />
      </main>
    </>
  );
};

export default AppRoute;
